<template>
  <svg id="wine_bottle" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><g id="bottle"><path d="m48.277,8.897c-.552,0-1,.448-1,1v17.665c0,4.384-3.587,7.951-6.092,11.382-2.478,3.404-4.065,6.944-4.065,11.274v36.42c1.252.409,5.092,1.362,12.88,1.362,7.842,0,11.628-.953,12.88-1.362v-36.42c0-4.33-1.559-7.87-4.065-11.274-2.505-3.431-6.092-6.998-6.092-11.382V9.897c0-.552-.448-1-1-1h-3.446Z" style="fill:none; stroke:#000; stroke-linecap:round; stroke-miterlimit:10; stroke-width:2px;"/></g></svg>
</template>
<script>
export default { name: 'wine-bottle-magnum' }
</script>
